import Vue from "vue";
import "./plugins/meta";
import "regenerator-runtime/runtime";
import vuetify from "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";
import i18n from "@/plugins/i18n";
import "vuetify/dist/vuetify.min.css";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import StatusIcon from "@/components/Shared/StatusIcon";
import vueCountryRegionSelect from "vue-country-region-select";
import VeeValidate from "vee-validate";
import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";

Vue.use(vueCountryRegionSelect);
Vue.use(VeeValidate);
Vue.use(VuePlyr, {
  plyr: {}
});

Vue.config.productionTip = false;

Vue.use(PerfectScrollbar);
Vue.component("status-icon", StatusIcon);

// Add a global mixin to safely handle user data access
Vue.mixin({
  computed: {
    safeCurrentUser() {
      return this.$store.getters.currentUser || {};
    }
  },
  methods: {
    // Safe property access helper
    safeGet(obj, path, defaultValue = "") {
      return path.split(".").reduce((prev, curr) => {
        return prev && prev[curr] !== undefined ? prev[curr] : defaultValue;
      }, obj);
    },
    // Global method to refresh translations
    async refreshTranslations() {
      try {
        console.log("🔄 Refreshing translations from component...");
        await this.$store.dispatch("loadTranslationData");
        console.log("✅ Translations refreshed successfully");
      } catch (error) {
        console.error("❌ Error refreshing translations:", error);
      }
    }
  }
});

//Filters
import DateFilter from "@/filters/date";
import NumberFilter from "@/filters/number";
import LongDateFilter from "@/filters/longdate";
import TimeFilter from "@/filters/time";
import TimeStampFilter from "@/filters/timestamp";
import ShortDate from "@/filters/shortdate";
import Truncate from "@/filters/truncate";
import Number from "@/filters/number";
import ConvertTimestamp from "@/filters/convertTimestamp";

Vue.filter("time", TimeFilter);
Vue.filter("timestamp", TimeStampFilter);
Vue.filter("date", DateFilter);
Vue.filter("number", NumberFilter);
Vue.filter("longdate", LongDateFilter);
Vue.filter("shortdate", ShortDate);
Vue.filter("truncate", Truncate);
Vue.filter("number", Number);
Vue.filter("convertTimestamp", ConvertTimestamp); // handles raw Firebase timestamp

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
